import { createContext } from "react";

export const OpenStateContext = createContext();
